// import React, { useState, useEffect } from 'react'
// import { useSelector } from 'react-redux'
// import { Link } from 'react-router-dom'
// import NumberFormat from 'react-number-format'

import { Grid, Select, MenuItem, FormControl, InputLabel, TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

// import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import './modalDatosIniciales.css';
// import { Loading } from '../../reusableUI/Loading';
// import { Model } from '../../../models/model';
// import { DialogFlowGeneral } from './flows/DialogFlowGeneral';

// import { budgetsUpdateProjections } from '../../../redux/actions/pptos';

export const PptosCondicionesFormasDePago = ({ setForm, form, listaFormasPagos, handleSubmit, yesModify }) => {

    // const dispatch = useDispatch()
    // const pptoInfo = useSelector(state => state.ppto.detail)

    //const {
    // id: pptoId,
    // estado_negocio,
    // total_ingresos_por_proyectar,
    // total_cliente,
    // projections = [],
    // separacion_miles,
    // separacion_decimales,
    // simbolo
    // } = pptoInfo

    // const [showLoading, setShowLoading] = useState(false)
    // const [openDialogModalProjections, setOpenDialogModalProjections] = useState(false)
    // const [globalsFlows, setGlobalsFlows] = useState(projections.filter(it => it.flujo_global === true))
    // const [newSaldoPorProyectar, setNewSaldoPorProyectar] = useState(total_ingresos_por_proyectar)
    // console.log({ newSaldoPorProyectar })

    // useEffect(() => {
    //     const newFlows = projections.filter(it => it.flujo_global === true)
    //     setGlobalsFlows(newFlows)
    // }, [projections])

    // const updateBalance = async (newListFormas) => {

    //     let newSum = 0
    //     for (let x = 0; x < newListFormas.length; x++) {
    //         newSum = newSum + parseFloat(newListFormas[x].monto_neto_estimado)
    //     }

    //     const newSaldo = parseFloat(total_ingresos_por_proyectar) - newSum
    //     setNewSaldoPorProyectar(newSaldo)
    // }

    const handleChangeFormaPago = ({ target }) => {
        const found = listaFormasPagos.find(it => parseInt(it.id) === parseInt(target.value))
        const dias = found ? parseInt(found?.dias || 0) : 0
        const newEstimatedDate = moment(new Date()).add(dias, 'days').format('YYYY-MM-DD')

        setForm({
            ...form,
            [target.name]: target.value,
            fecha_estimada_forma_pago: newEstimatedDate
        });

    }

    // const handleAddFormaPago = () => {

    //     let newListFormas = []

    //     if (form.otras_formas_pago.length === 0) {
    //         setNewSaldoPorProyectar(total_ingresos_por_proyectar)

    //         const foundFP = listaFormasPagos.find(it => it.id == form.id_forma_pago)
    //         const dias = foundFP ? parseInt(foundFP?.dias || 30) : 30

    //         const newFechaEstimada = moment(new Date(form.fecha_estimada_forma_pago)).format('YYYY-MM-DD')

    //         if (!newFechaEstimada) {
    //             newFechaEstimada = moment(new Date()).add(dias, 'days').format('YYYY-MM-DD')
    //         }

    //         newListFormas = [
    //             ...form.otras_formas_pago,
    //             {
    //                 id: form.id_forma_pago,
    //                 fecha: newFechaEstimada,
    //                 mostrar_pdf: true,
    //                 id_temp: uuidv4(),
    //                 dias: form?.dias || 30,
    //                 porcentaje: form?.porcentaje,
    //                 monto_neto_estimado: 0
    //             }
    //         ]

    //         newListFormas = [
    //             ...newListFormas,
    //             {
    //                 id: uuidv4(),
    //                 fecha: new Date(),
    //                 mostrar_pdf: false,
    //                 id_temp: uuidv4(),
    //                 dias: 0,
    //                 porcentaje: 0,
    //                 monto_neto_estimado: 0
    //             }
    //         ]

    //     } else {

    //         newListFormas = [
    //             ...form.otras_formas_pago,
    //             {
    //                 id: uuidv4(),
    //                 fecha: new Date(),
    //                 mostrar_pdf: false,
    //                 id_temp: uuidv4(),
    //                 dias: 0,
    //                 porcentaje: 0,
    //                 monto_neto_estimado: 0
    //             }
    //         ]

    //     }

    //     setForm({
    //         ...form,
    //         otras_formas_pago: newListFormas
    //     })

    // }

    // const handleRemoveFormas = async (idTempRemove) => {
    //     const newListFormas = form.otras_formas_pago.filter(fp => fp.id_temp !== idTempRemove)

    //     setForm({
    //         ...form,
    //         otras_formas_pago: newListFormas
    //     })

    //     await updateBalance(newListFormas)

    // }

    // const handleChangeDateForma = async ({ target }, idSelectedTemp) => {
    //     const newId = target.value
    //     const foundId = listaFormasPagos.find(fp => parseInt(fp.id) === parseInt(newId))

    //     if (foundId) {

    //         const newListUpdated = form.otras_formas_pago.map((fp, index) => {
    //             if (fp.id_temp === idSelectedTemp) {

    //                 const factorDias = index + 1
    //                 const dias = (foundId ? parseInt(foundId?.dias || 30) : 30) * factorDias
    //                 const newFechaEstimada = moment(new Date()).add(dias, 'days').format('YYYY-MM-DD')
    //                 const newIdSelected = foundId?.id
    //                 const newDias = parseInt(foundId?.dias) > 0 ? parseInt(foundId?.dias) : 30
    //                 const newPorcentaje = parseInt(foundId?.porcentaje) > 0 ? parseInt(foundId?.porcentaje) : 0
    //                 const newMontoNetoEstimado = parseFloat(total_ingresos_por_proyectar) * (newPorcentaje / 100)

    //                 return {
    //                     ...fp,
    //                     id: newIdSelected,
    //                     fecha_estimada: newFechaEstimada,
    //                     dias: newDias,
    //                     porcentaje: newPorcentaje,
    //                     monto_neto_estimado: newMontoNetoEstimado
    //                 }

    //             }

    //             return fp
    //         })

    //         setForm({
    //             ...form,
    //             otras_formas_pago: newListUpdated
    //         })

    //         await updateBalance(newListUpdated)

    //     }

    // }

    const handleChangeDateEstimated = (newValue) => {
        setForm({
            ...form,
            fecha_estimada_forma_pago: newValue
        })
    }

    // const handleChangeDateList = (newDateIn, idSelected) => {
    //     const newDate = moment(new Date(newDateIn)).format('YYYY-MM-DD')

    //     const newListUpdated = form.otras_formas_pago.map(fp => {
    //         if (fp.id === idSelected) {
    //             return {
    //                 ...fp,
    //                 fecha_estimada: newDate
    //             }
    //         }

    //         return fp
    //     })

    //     setForm({
    //         ...form,
    //         otras_formas_pago: newListUpdated
    //     })

    // }

    // const handleChangePercent = async (values, idSelectedTemp) => {
    //     if (!values.sourceInfo.event) return false

    //     const { floatValue: newPorcentaje } = values
    //     const newListUpdated = form.otras_formas_pago.map(fp => {
    //         const newMontoNetoEstimado = parseFloat(total_ingresos_por_proyectar) * (newPorcentaje / 100)
    //         setNewSaldoPorProyectar(newSaldoPorProyectar - newMontoNetoEstimado)

    //         if (fp.id_temp === idSelectedTemp) {
    //             return {
    //                 ...fp,
    //                 porcentaje: newPorcentaje,
    //                 monto_neto_estimado: newMontoNetoEstimado
    //             }
    //         }

    //         return fp
    //     })

    //     setForm({
    //         ...form,
    //         otras_formas_pago: newListUpdated
    //     })

    //     await updateBalance(newListUpdated)

    // }

    // const handleGenerateFlow = async (e) => {

    //     setShowLoading(true)

    //     const initialGenerate = async () => {

    //         let flowsList = []
    //         for (let x = 0; x < form?.otras_formas_pago.length; x++) {

    //             const porcentaje = parseFloat(form?.otras_formas_pago[x]?.porcentaje || 0)
    //             const montoNetoFlow = parseFloat(total_ingresos_por_proyectar) * (porcentaje / 100)
    //             const totalFlow = montoNetoFlow * 1.18
    //             const fechaFlow = moment(form?.otras_formas_pago[x].fecha_estimada).format('YYYY-MM-DD')

    //             const newFlow = {
    //                 id: null,
    //                 saved: false,
    //                 id_contacto: pptoInfo?.id_cliente,
    //                 id_ppto: pptoInfo.id,
    //                 tipo_flujo: 'ingreso',
    //                 porcentaje_flow: porcentaje,
    //                 referencia: '',
    //                 monto_neto: montoNetoFlow,
    //                 id_doc: 1, // factura 18%
    //                 porcentaje_impuesto: 18,
    //                 total: totalFlow,
    //                 fecha_proyeccion: fechaFlow,
    //                 id_moneda: pptoInfo?.id_moneda,
    //                 valor_tipo_cambio: pptoInfo?.valor_tipo_cambio,
    //                 id_item_ppto: null,
    //                 total_item_ppto: null,
    //                 id_tarea: null,
    //                 flujo_global: true
    //             }

    //             flowsList = [
    //                 ...flowsList,
    //                 newFlow
    //             ]

    //         }

    //         const resultGenerate = await Model.save({
    //             url: 'reports/projections/global/flow',
    //             dataForm: {
    //                 id_ppto: pptoInfo.id,
    //                 flows: flowsList
    //             },
    //             resultData: true
    //         })

    //         dispatch(budgetsUpdateProjections(resultGenerate))
    //         setShowLoading(false)

    //     }

    //     handleSubmit(e)
    //     setTimeout(initialGenerate, 1000)

    // }

    return (
        <>

            {/* {form.otras_formas_pago.length === 0 ?
                <> */}
            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">Forma de pago</InputLabel>
                    <Select
                        label="Forma de pago"
                        id="id_forma_pago"
                        name="id_forma_pago"
                        value={form.id_forma_pago || ''}
                        onChange={handleChangeFormaPago}
                        className='p-list-capitalize'
                        disabled={!yesModify}
                    >
                        <MenuItem value='' key=''>Ninguno</MenuItem>
                        {listaFormasPagos.map(item => (
                            <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={6} className='p-text-date-range'>
                <span>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha pago"
                            inputFormat="DD/MM/YYYY"
                            name="fecha_estimada_forma_pago"
                            value={form?.fecha_estimada_forma_pago || new Date()}
                            onChange={handleChangeDateEstimated}
                            renderInput={(params) => <TextField {...params} />}
                            disabled={!yesModify}
                        />
                    </LocalizationProvider>
                </span>
            </Grid>
            {/* </> : ''
            } */}

            {/* <Grid item
                xs={form.otras_formas_pago.length === 0 ? 4 : 12}
                className={form.otras_formas_pago.length === 0 ? 'text-center' : 'text-end'}
            >
                <button
                    type="button"
                    className="btn btn-link p-links-line"
                    onClick={handleAddFormaPago}
                >
                    + Agregar forma de pago
                </button>
            </Grid> */}

            {/* {form.otras_formas_pago.length > 0 ?
                <Grid item xs={12}>
                    <div className='text-end me-2'>
                        <label style={{ fontWeight: 'bold' }}>Total proyecto:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_cliente || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div className='text-end me-2'>
                        <label style={{ fontWeight: 'bold' }}>Saldo por proyectar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={newSaldoPorProyectar}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div className='m-2'>
                        <table className="table table-bordered p-table-report">
                            <thead>
                                <tr>
                                    <th>Formas de pago</th>
                                    <th>Fecha estimada</th>
                                    <th>% Facturación</th>
                                    <th>Quitar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {form.otras_formas_pago.map((fp, index) => (
                                    <tr key={index}>
                                        <th className='text-center d-flex flex-column justify-content-start align-items-start'>
                                            <select
                                                style={{
                                                    padding: '5px',
                                                    borderRadius: '5px'
                                                }}
                                                onChange={(e) => handleChangeDateForma(e, fp.id_temp)}
                                                disabled={globalsFlows?.length > 0}
                                            >
                                                <option value="">--seleccionar--</option>
                                                {listaFormasPagos.map(item => (
                                                    <option
                                                        key={item.id}
                                                        value={item.id}
                                                        selected={item.id == fp?.id ? 'selected' : ''}
                                                    >
                                                        {item.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {parseInt(fp?.dias) > 0 ?
                                                <span className='ms-2 mt-1'>En {fp?.dias || 0} días más</span> : ''
                                            }
                                        </th>
                                        <td className='text-center'>
                                            <div className='p-text-date-range'>
                                                <span>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DesktopDatePicker
                                                            label=" "
                                                            inputFormat="DD/MM/YYYY"
                                                            name="fecha_estimada"
                                                            value={fp.fecha_estimada}
                                                            disabled={globalsFlows?.length > 0}
                                                            onChange={(value) => handleChangeDateList(value, fp.id)}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </span>
                                            </div>
                                        </td>
                                        <td className='text-end'>
                                            <div className='d-flex flex-column align-items-end justify-content-end'>
                                                <NumberFormat
                                                    className="p-2 text-end"
                                                    style={{
                                                        border: '1px solid lightgray',
                                                        borderRadius: '5px'
                                                    }}
                                                    id="outlined-size-small"
                                                    size="small"
                                                    disabled={globalsFlows?.length > 0}
                                                    name="porcentaje"
                                                    value={fp?.porcentaje || 0}
                                                    onValueChange={(values, sourceInfo) => handleChangePercent({ ...values, sourceInfo }, fp.id_temp)}
                                                    suffix='%'
                                                    decimalScale={2}
                                                    fixedDecimalScale
                                                />
                                                <NumberFormat
                                                    size="small"
                                                    displayType={'text'}
                                                    name="monto_neto_estimado"
                                                    className="text-end me-1"
                                                    value={fp?.monto_neto_estimado || 0}
                                                    thousandSeparator={separacion_miles}
                                                    decimalSeparator={separacion_decimales}
                                                    prefix={`${simbolo} `}
                                                    decimalScale={2}
                                                    fixedDecimalScale={2}
                                                />
                                            </div>
                                        </td>
                                        <td className='text-center'>
                                            <button
                                                type="button"
                                                disabled={globalsFlows?.length > 0}
                                                className="btn btn-link"
                                                onClick={() => handleRemoveFormas(fp.id_temp)}
                                            >
                                                <i className="bi bi-trash" style={{ color: 'gray', fontSize: '14px' }}></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Grid> : ''
            } */}

            {/* {(estado_negocio === 'aprobado' && form?.otras_formas_pago.length > 0) ?
                <Grid item xs={12} className="d-flex flex-column justify-content-end align-items-end">
                    {globalsFlows?.length > 0 ?
                        <div className='me-2'>
                            <Link
                                to=""
                                className='p-links-line'
                                onClick={() => setOpenDialogModalProjections(true)}
                            >
                                Ver flujos creados {globalsFlows?.length || 0}
                            </Link>
                        </div>
                        :
                        <div>
                            {showLoading ?
                                <span className='me-3'>
                                    <Loading text="creando flujos..." />
                                </span>
                                :
                                <button
                                    type="button"
                                    className="btn btn-link p-links-line"
                                    onClick={handleGenerateFlow}
                                >
                                    <i className="bi bi-arrow-clockwise"></i>
                                    <span className='ms-1'>Generar flujos</span>
                                </button>
                            }
                        </div>
                    }
                </Grid> : ''
            } */}

            {/* {openDialogModalProjections ?
                <DialogFlowGeneral
                    open={openDialogModalProjections}
                    setOpen={setOpenDialogModalProjections}
                    item={{ id: null }}
                    tasksList={[]}
                    currentTasks={{ id: null }}
                    refreshObj={() => false}
                /> : ''
            } */}



        </>
    )
}